import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { DeviceContext } from "../context/DeviceContext";

const ShareDialog = ({ open, url, handleClose, handleCopy }) => {
  const { isMobile } = React.useContext(DeviceContext);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          width: isMobile ? "90%" : "30%",
          maxWidth: "100%",
        },
      }}>
      <DialogTitle>Share Post</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          value={url}
          InputProps={{
            readOnly: true,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleCopy} color="primary">
          Copy
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShareDialog;
